import React from 'react';
import Navbar from '../components/Navbar';
import '../App.css';
import './AboutPage.css';

const AboutPage = () => {
  return (
    <div className="App">
      <Navbar />
      <main className="about-container">
        <section className="about-hero">
          <h1>About Aspen Quick Care</h1>
          <p className="about-subtitle">Providing fast, reliable urgent care services to our community with compassion and excellence.</p>
        </section>
        
        <section className="about-content">
          <h2>Our Mission</h2>
          <p>
            Aspen Quick Care offers comprehensive urgent care services including treatment for minor injuries, 
            infections, flu symptoms, sprains, cuts, and more. We provide on-site diagnostics, X-rays, and 
            lab services to ensure you receive complete care.
          </p>
          
          <h2>Our Facility</h2>
          <p>
            Our urgent care facility is equipped with modern medical technology and staffed by board-certified 
            physicians and experienced nurses. We accept most insurance plans and offer affordable self-pay 
            options for those without insurance.
          </p>
          
          <h2>When We're Here for You</h2>
          <p>
            Open 7 days a week to fit your schedule. Whether you need immediate care 
            for an injury, treatment for an illness, or urgent medical attention, our team is here to 
            provide fast, professional care when you need it most.
          </p>
        </section>
      </main>
    </div>
  );
};

export default AboutPage;
